/* Vornom product page behaviour (sections/vor-main-product.liquid). Port of upp-theme
   assets/upp-pdp.js (5950f48) without its US parts (delivery options and add-ons, lead times and
   dates, ready-to-ship pieces, sample packs, the UPP chair set, stock status) and, for now, without
   the size guide dialog. The size drawing (T9, snippets/vor-pdp-drawing) is drawn here on load and on
   every size change, when the section shows it.
   - option buttons -> variant: hidden id, ?variant= URL, price, per-size prices, size label, spec
     rows, sticky bar, the taksit line (snippets/vor-taksit-line: 6 × price ÷ 6) and the PayTR amount
   - gallery: scroll-snap track, arrows, thumbnails, counter, zoom dialog, videos on tap
   - chair box (snippets/vor-pdp-chairs, board 01-02): pick, count, option, remove; it sets
     window.vornomCombineChairs as the live box does (snippets/product-combine-chairs, old page)
   - add to cart: one /cart/add.js call for the table and the picked chairs; the theme's cart
     drawer opens through the events theme.AjaxProduct fires (ajaxProduct:adding / :added /
     :addFailed), with the drawer section in the response
   - sticky add-to-cart bar (phones and desktop) once the main button has scrolled away
   - PayTR table (snippets/vor-pdp-paytr): opens on its button or the taksit line's link
   - records the product for the theme's recently viewed list
   Events: also fires the theme's document "variant:change" (the chair box and assets/vor-events.js
   listen to it). GA4 only through assets/vor-events.js (data-vor-* attributes). */
(function () {
  'use strict';

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function Pdp(root) {
    this.root = root;
    var json = $(root, '[data-vor-pdp-json]');
    try { this.data = JSON.parse(json ? json.textContent : '{}'); } catch (e) { this.data = {}; }
    this.variants = this.data.variants || [];
    this.form = $(root, '[data-vor-form]');
    this.atc = $(root, '[data-vor-atc]');
    var cur = $(root, '[data-vor-variant-id]');
    this.variant = this.findById(cur ? Number(cur.value) : 0) || this.variants[0];

    this.initOptions();
    this.initGallery();
    if (this.variant) this.updateSize(this.variant);
    this.initChairs();
    this.initDrawing();
    if (this.variant) this.updateButtons();
    this.initForm();
    this.initBar();
    this.initPaytr();
    this.recordRecent();
  }

  /* The theme's money format without trailing zeros, as Liquid's money_without_trailing_zeros (UPP and
     the vor-product-card cards): "34,590 ₺", "4,531.67 ₺". Shop setting "{{amount}} ₺" today; Turkish
     separators are owner decision A13. */
  Pdp.prototype.money = function (cents) {
    var s = (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat)
      ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
      : (cents / 100).toFixed(2) + ' ₺';
    return s.replace(/([.,])00(?!\d)/, '');
  };

  Pdp.prototype.findById = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (this.variants[i].id === id) return this.variants[i];
    return null;
  };

  /* ---------- Options ---------- */
  Pdp.prototype.initOptions = function () {
    var self = this;
    this.optionInputs = $$(this.root, '[data-vor-opt-input]');
    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(Number(input.getAttribute('data-vor-opt-input'))); });
    });
  };

  Pdp.prototype.selected = function () {
    var sel = this.variant ? this.variant.options.slice() : [];
    this.optionInputs.forEach(function (input) {
      if (input.checked) sel[Number(input.getAttribute('data-vor-opt-input'))] = input.value;
    });
    return sel;
  };

  Pdp.prototype.onOptionChange = function (changed) {
    var sel = this.selected();
    var exact = null, best = null, bestScore = -1;
    this.variants.forEach(function (v) {
      if (v.options[changed] !== sel[changed]) return;
      var score = 0;
      for (var i = 0; i < v.options.length; i++) if (v.options[i] === sel[i]) score++;
      if (score === v.options.length) exact = v;
      if (score > bestScore || (score === bestScore && v.available && best && !best.available)) { best = v; bestScore = score; }
    });
    var v = exact || best;
    if (!v) return;
    this.setVariant(v, true);
  };

  Pdp.prototype.sizeInfo = function (value) {
    var sizes = this.data.sizes || [];
    for (var i = 0; i < sizes.length; i++) if (sizes[i].value === value) return sizes[i];
    return null;
  };

  Pdp.prototype.setVariant = function (v, fromUser) {
    var self = this, root = this.root;
    this.variant = v;

    // radios follow the variant (a missing combination may have moved another option)
    this.optionInputs.forEach(function (input) {
      var oi = Number(input.getAttribute('data-vor-opt-input'));
      input.checked = v.options[oi] === input.value;
    });

    $$(root, 'form input[name="id"]').forEach(function (input) {
      input.value = v.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (fromUser && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    // price; a real compare-at only (snippets/vor-pdp-price): struck price + "X ₺ indirim", no badge
    var from = $(root, '[data-vor-from]');
    if (from && fromUser) from.hidden = true;
    var price = $(root, '[data-vor-pdp-price]');
    if (price) price.textContent = this.money(v.price);
    var disc = v.compare > v.price;
    var cmp = $(root, '[data-vor-compare]');
    if (cmp) {
      cmp.hidden = !disc;
      $(cmp, '[data-vor-compare-amount]').textContent = disc ? this.money(v.compare) : '';
    }
    var save = $(root, '[data-vor-save]');
    if (save) {
      save.hidden = !disc;
      $(save, '[data-vor-save-amount]').textContent = disc ? this.money(Math.max(0, v.compare - v.price)) : '';
    }
    var saleLabel = $(root, '[data-vor-sale-label]');
    if (saleLabel) saleLabel.hidden = !disc;

    this.updateTaksit(v);

    // option labels + availability / per-value prices
    $$(root, '[data-vor-option]').forEach(function (fs) {
      var oi = Number(fs.getAttribute('data-vor-option'));
      var label = $(fs, '[data-vor-opt-label="' + oi + '"]');
      if (label) {
        var info = oi === self.data.sizeIdx ? self.sizeInfo(v.options[oi]) : null;
        label.textContent = info && info.cm ? (info.name ? info.name + ' · ' : '') + info.cm : v.options[oi];
      }
      $$(fs, '[data-vor-opt-input]').forEach(function (input) {
        var match = self.variants.filter(function (c) {
          if (c.options[oi] !== input.value) return false;
          for (var i = 0; i < c.options.length; i++) if (i !== oi && c.options[i] !== v.options[i]) return false;
          return true;
        })[0];
        var btn = input.closest('label');
        btn.classList.toggle('is-unavailable', !match || !match.available);
        var p = $(btn, '[data-vor-opt-price]');
        if (p) p.textContent = match ? self.money(match.price) : '';
      });
    });

    this.updateSize(v);
    this.updateButtons();
    /* a size picked on the drawing tile's chips keeps the gallery on the drawing (owner 2026-10-23: it jumped to
       the variant photo, often the first image) */
    if (fromUser && !this.dwPick) this.showMedia(v.media);
    this.dwPick = false;

    $$(root, '[data-vor-spec-opt]').forEach(function (td) {
      td.textContent = v.options[Number(td.getAttribute('data-vor-spec-opt'))] || '';
    });

    root.dispatchEvent(new CustomEvent('vor:variant-change', { bubbles: true, detail: { variant: v } }));
    /* the theme's event: the chair box updates "N adet önerilir" from variant.title, T0a reads the price */
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
  };

  /* Taksit line (snippets/vor-taksit-line) and the PayTR amount follow the price. */
  Pdp.prototype.updateTaksit = function (v) {
    var self = this;
    $$(this.root, '[data-vor-taksit]').forEach(function (box) {
      var amount = $(box, '[data-vor-taksit-amount]');
      if (amount) amount.textContent = '6 × ' + self.money(Math.round(v.price / 6));
      var total = $(box, '[data-vor-taksit-total]');
      if (total) total.textContent = self.money(v.price);
      var link = $(box, '[data-vor-taksit-open]');
      if (link) link.setAttribute('data-vor-p-price', (v.price / 100).toFixed(2));
    });
    var pt = $(this.root, '[data-vor-paytr]');
    if (pt) {
      pt.setAttribute('data-vor-paytr-amount', (v.price / 100).toFixed(2));
      if (this.paytrStale) this.paytrStale();
    }
  };

  Pdp.prototype.updateSize = function (v) {
    var root = this.root, idx = this.data.sizeIdx;
    if (idx == null || idx < 0) return;
    var info = this.sizeInfo(v.options[idx]) || { value: v.options[idx] };
    var sizeText = info.cm || info.value;
    var cell = $(root, '[data-vor-spec-size]');
    if (cell) cell.textContent = sizeText;
    var seatsRow = $(root, '[data-vor-spec-seats-row]');
    if (seatsRow) {
      seatsRow.hidden = !info.seats;
      $(seatsRow, '[data-vor-spec-seats]').textContent = info.seats || '';
    }
    $$(root, '[data-vor-bar-size]').forEach(function (el) { el.textContent = sizeText; });
    /* category size guide (snippets/vor-pdp-size-guide): the "Bu ölçü için" lines, plain arithmetic on the
       approved R1-R7 numbers; hidden when the size could not be read */
    var ca = +info.ca || 0, cb = +info.cb || 0, n = +info.count || 0;
    if (cb <= 0 && this.data.round) cb = ca;
    $$(root, '[data-vor-sg-calc]').forEach(function (el) {
      var kind = el.getAttribute('data-vor-sg-calc'), txt = '';
      if (kind === 'dining' && ca > 0) txt = Math.round(ca + 182) + ' × ' + Math.round((cb || ca) + 182) + ' cm';
      else if (kind === 'desk' && cb > 0) txt = Math.round(cb + 91) + ' cm';
      else if (kind === 'coffee' && ca > 0) txt = Math.round(ca * 1.5) + ' cm';
      else if (kind === 'console' && n > 1 && cb > 0) txt = Math.round(cb + 91) + ' cm';
      else if (kind === 'tv' && ca > 0) txt = Math.floor(ca / 2.21) + ' inç';
      var val = $(el, '[data-vor-sg-val]');
      if (val) val.textContent = txt;
      el.hidden = !txt;
    });
    this.drawSize(info);
    this.markDwSize();
    /* chair box: "Bu masa için N adet önerilir" and the count "+ Ekle" starts at */
    var box = $(root, '[data-vor-chairs]');
    if (box && info.seats) {
      box.setAttribute('data-vor-ch-rec', info.seats);
      var recN = $(box, '[data-vor-ch-rec-n]');
      if (recN) recN.textContent = info.seats;
    }
  };

  /* ---------- Size drawing (snippets/vor-pdp-drawing, same geometry) ----------
     viewBox 300 x 240, table centred on (150, 125), one scale for all sizes (the largest fits 180 x 110,
     a round one 140 across), chair markers r 14 set 8 from the edge: 2 at the ends, the rest along the
     long sides; evenly round a round table. */
  Pdp.prototype.initDrawing = function () {
    var self = this;
    this.dw = $(this.root, '[data-vor-dw]');
    if (!this.dw) return;
    var maxA = 0, maxB = 0;
    (this.data.sizes || []).forEach(function (z) {
      var x = Number(z.ca) || 0, y = Number(z.count) === 1 ? x : (Number(z.cb) || 0);
      if (y > x) { var t = x; x = y; y = t; }
      maxA = Math.max(maxA, x); maxB = Math.max(maxB, y);
    });
    this.dwMax = { a: maxA, b: maxB };
    this.initDwSizes();
    if (this.variant && this.data.sizeIdx > -1) this.drawSize(this.sizeInfo(this.variant.options[this.data.sizeIdx]));
    this.markDwSize();
    $$(this.root, '[data-vor-dw-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.openDrawing(); });
    });
  };

  /* Size chips in the drawing tile (owner 2026-10-22: "değerlerin değişebilir ve seçilebilir olduğunu gösterelim"):
     one button per size; a tap ticks that size's option radio, so the variant, price and drawing follow as
     after a pick in the form. Built here (no first paint without JS: nothing to pick then). The chips and the
     caption share a foot bar. */
  Pdp.prototype.initDwSizes = function () {
    var self = this, sizes = this.data.sizes || [], idx = this.data.sizeIdx;
    if (!this.dw || sizes.length < 2 || !(idx > -1)) return;
    var foot = document.createElement('div'), box = document.createElement('div');
    foot.className = 'vor-pdp-dw__foot';
    box.className = 'vor-pdp-dw__sizes';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Ölçü seçin');
    sizes.forEach(function (z) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vor-pdp-dw__size';
      btn.setAttribute('data-vor-dw-size', z.value);
      btn.textContent = z.cm || z.value;
      box.appendChild(btn);
    });
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vor-dw-size]');
      if (!btn) return;
      var value = btn.getAttribute('data-vor-dw-size');
      var input = self.optionInputs.filter(function (i) { return Number(i.getAttribute('data-vor-opt-input')) === idx && i.value === value; })[0];
      if (!input || input.checked) return;
      input.checked = true;
      self.dwPick = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      self.dwPick = false;
    });
    var cap = $(this.dw, '[data-vor-dw-cap]');
    foot.appendChild(box);
    if (cap) foot.appendChild(cap);
    this.dw.appendChild(foot);
    this.dwSizes = box;
  };

  Pdp.prototype.markDwSize = function () {
    if (!this.dwSizes || !this.variant) return;
    var box = this.dwSizes, cur = this.variant.options[this.data.sizeIdx];
    $$(box, '[data-vor-dw-size]').forEach(function (btn) {
      var on = btn.getAttribute('data-vor-dw-size') === cur;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* the room view's chip row scrolls sideways: keep the selected chip in view (not scrollIntoView: no page jump) */
      if (on && box.scrollWidth > box.clientWidth) {
        var left = btn.offsetLeft - box.offsetLeft;
        if (left < box.scrollLeft || left + btn.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollLeft = Math.max(0, left - 16);
      }
    });
  };

  Pdp.prototype.drawSize = function (info) {
    var fig = this.dw, max = this.dwMax;
    if (!fig || !info || !max || !max.a) return;
    var svg = $(fig, '[data-vor-dw-svg]'), cap = $(fig, '[data-vor-dw-cap]');
    var a = Number(info.ca) || 0, b = Number(info.cb) || 0, n = Number(info.count) || 0;
    var seats = this.data.dining ? (Number(info.seats) || 0) : 0;
    if (b > a) { var t = a; a = b; b = t; }
    var kind = n === 2 && a > 0 && b > 0 ? 'rect' : (n === 1 && this.data.round && a > 0 ? 'circle' : '');
    if (!kind || !svg) return;
    /* dining table with seats: UPP's room view (room photo, top-view chairs, the product's tabletop) */
    if (seats > 0 && fig.getAttribute('data-room-src')) {
      this.drawRoom(fig, svg, cap, kind, a, b, seats, info);
      return;
    }
    fig.classList.remove('is-room', 'is-room-wait');
    svg.removeAttribute('preserveAspectRatio');
    var r1 = function (v) { return Math.round(v * 10) / 10; };
    var CR = 14, GAP = 8, OFF = CR + GAP, out = [];
    var chair = function (x, y) { out.push('<circle class="vor-pdp-dw__chair" cx="' + r1(x) + '" cy="' + r1(y) + '" r="' + CR + '"/>'); };
    var txt = function (x, y, s, rot) { out.push('<text class="vor-pdp-dw__txt" x="' + x + '" y="' + y + '" text-anchor="middle"' + (rot ? ' transform="rotate(90 ' + x + ' ' + y + ')"' : '') + '>' + s + '</text>'); };
    if (kind === 'rect') {
      var sc = Math.min(180 / max.a, max.b ? 110 / max.b : 110);
      var w = r1(a * sc), h = r1(b * sc), x0 = r1(150 - w / 2), y0 = r1(125 - h / 2), x1 = r1(x0 + w), y1 = r1(y0 + h);
      out.push('<path class="vor-pdp-dw__dim" d="M' + x0 + ' 22H' + x1 + 'M' + x0 + ' 17v10M' + x1 + ' 17v10"/>');
      txt(150, 12, a + ' cm');
      out.push('<path class="vor-pdp-dw__dim" d="M286 ' + y0 + 'V' + y1 + 'M281 ' + y0 + 'h10M281 ' + y1 + 'h10"/>');
      txt(296, 125, b + ' cm', true);
      if (seats > 0) {
        var per = seats >= 4 ? Math.floor((seats - 2) / 2) : 1;
        if (seats >= 4) { chair(x0 - OFF, 125); chair(x1 + OFF, 125); }
        for (var i = 1; i <= per; i++) {
          var cx = x0 + (i - 0.5) * w / per;
          chair(cx, y0 - OFF); chair(cx, y1 + OFF);
        }
      }
      out.push('<rect class="vor-pdp-dw__table" x="' + x0 + '" y="' + y0 + '" width="' + w + '" height="' + h + '" rx="4"/>');
    } else {
      var rad = r1(a * (140 / max.a) / 2), ring = rad + OFF;
      if ([4, 6, 8, 10].indexOf(seats) > -1) {
        for (var k = 0; k < seats; k++) { var ang = 2 * Math.PI * k / seats; chair(150 + Math.cos(ang) * ring, 125 + Math.sin(ang) * ring); }
      }
      out.push('<circle class="vor-pdp-dw__table" cx="150" cy="125" r="' + rad + '"/>');
      out.push('<path class="vor-pdp-dw__dim vor-pdp-dw__dim--dash" d="M' + r1(150 - rad) + ' 125H' + r1(150 + rad) + '"/>');
      txt(150, 118, 'Ø ' + a + ' cm');
    }
    svg.innerHTML = out.join('');
    var cm = info.cm || info.value;
    svg.setAttribute('aria-label', 'Üstten ölçü çizimi: ' + cm + (kind === 'circle' ? ' yuvarlak' : '') + (seats ? ' masa ve ' + seats + ' sandalye' : ''));
    if (cap) cap.textContent = (seats ? seats + ' kişilik · ' : '') + cm;
  };

  /* Chair width in the room view (owner 2026-10-22: "PDP masalarda sandalye genişliğini de göster"): the
     picked chair's custom.genislik_cm (data-vor-ch-w on its row, snippets/vor-pdp-chairs), else the box's
     first chair's. No value (or no chair box): null, and drawRoom labels the generic 46 cm chair it draws. */
  Pdp.prototype.chairWidth = function () {
    var box = $(this.root, '[data-vor-chairs]');
    var item = box && ($(box, '[data-combine-chair].is-selected') || $(box, '[data-combine-chair]'));
    var w = item ? Number(item.getAttribute('data-vor-ch-w')) : 0;
    if (!(w >= 25 && w <= 150)) return null;
    var name = $(item, '.vor-ch__name');
    return { w: w, name: name ? name.textContent.trim() : '' };
  };

  Pdp.prototype.redrawDw = function () {
    if (this.dw && this.variant && this.data.sizeIdx > -1) this.drawSize(this.sizeInfo(this.variant.options[this.data.sizeIdx]));
  };

  /* Room view (port of upp-pdp.js drawRoom, cm): UPP's top-down room (floor = x 77-956, y 85-944 of 1024 px,
     declared 427 cm wide) with the table and chairs drawn over it at one scale. Chair footprint 46 x 46 cm,
     5 cm from the table (generic); with a real chair width (chairWidth) the chairs are that wide and one
     chair nearest the viewer gets a "Sandalye N cm" dimension line. The chair image fills the footprint
     (backrest away from the table); the tabletop is data-top-src cropped, not stretched, else flat. From
     4 chairs one goes at each end (when the end is wide enough), the rest split along the long sides;
     round tables: evenly round. */
  Pdp.prototype.drawRoom = function (fig, svg, cap, kind, a, b, n, info) {
    var F = { x: 77, y: 85, w: 879, h: 859 }, s = F.w / 427;
    /* owner 2026-10-22: the width shown is that of the chairs drawn round the table, so without a chair's own
       custom.genislik_cm the label gives the drawing's 46 cm footprint */
    var chairW = this.chairWidth() || { w: 46, name: '' };
    var CW = chairW.w, CD = 46, GAP = 5, OUT = GAP + CD;
    var r = function (v) { return Math.round(v * 10) / 10; };
    var WOOD_D = '#3B2716', INK = '#1A1512', TOPC = '#FCFAF6';
    var chairSrc = fig.getAttribute('data-chair-src'), topSrc = fig.getAttribute('data-top-src');
    var clipId = 'vorTop' + Math.random().toString(36).slice(2, 8);
    var out = [];
    var chair = function (cx, cy, angle) {
      var w = CW * s, d = CD * s;
      out.push('<g transform="translate(' + r(cx) + ' ' + r(cy) + ') rotate(' + angle + ')">' + (chairSrc
        ? '<image href="' + chairSrc + '" x="' + r(-w / 2) + '" y="' + r(-d / 2) + '" width="' + r(w) + '" height="' + r(d) + '" preserveAspectRatio="none"/>'
        : '<rect x="' + r(-w / 2) + '" y="' + r(-d / 2) + '" width="' + r(w) + '" height="' + r(d) + '" rx="' + r(d * 0.2) + '" fill="#2A2420"/>') + '</g>');
    };
    var top = function (shape, bx, by, bw, bh) {
      out.push(shape.replace('/>', ' fill="' + TOPC + '"/>'));
      if (topSrc) {
        out.push('<clipPath id="' + clipId + '">' + shape + '</clipPath>');
        var rot = bh > bw * 1.2;   /* the grain runs along the long side */
        out.push(rot
          ? '<image href="' + topSrc + '" x="' + r(bx + bw / 2 - bh / 2) + '" y="' + r(by + bh / 2 - bw / 2) + '" width="' + r(bh) + '" height="' + r(bw) + '" preserveAspectRatio="xMidYMid slice" transform="rotate(90 ' + r(bx + bw / 2) + ' ' + r(by + bh / 2) + ')" clip-path="url(#' + clipId + ')"/>'
          : '<image href="' + topSrc + '" x="' + r(bx) + '" y="' + r(by) + '" width="' + r(bw) + '" height="' + r(bh) + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + clipId + ')"/>');
      }
      out.push(shape.replace('/>', ' fill="none" stroke="' + WOOD_D + '" stroke-width="4"/>'));
    };
    var lbl = function (x, y, text, rot) {
      out.push('<text class="vor-pdp-dw__lbl" x="' + r(x) + '" y="' + r(y) + '" text-anchor="middle"' + (rot ? ' transform="rotate(' + rot + ' ' + r(x) + ' ' + r(y) + ')"' : '') + '>' + text + '</text>');
    };
    /* "Sandalye N cm" under a chair whose back faces the viewer (centre ccx, back edge at y): a dimension line
       as wide as the chair, the label beside it */
    var chairDim = function (ccx, y) {
      if (!chairW) return;
      var w = CW * s, x0 = ccx - w / 2, x1 = ccx + w / 2, yl = y + 16;
      out.push('<path class="vor-pdp-dw__cdim" d="M' + r(x0) + ' ' + r(yl - 9) + 'v18M' + r(x0) + ' ' + r(yl) + 'H' + r(x1) + 'M' + r(x1) + ' ' + r(yl - 9) + 'v18"/>');
      out.push('<text class="vor-pdp-dw__lbl vor-pdp-dw__lbl--chair" x="' + r(x1 + 14) + '" y="' + r(yl + 10) + '">Sandalye ' + CW + ' cm</text>');
    };
    var cx = F.x + F.w / 2, cy = F.y + F.h * 0.46;
    if (kind === 'rect') {
      var ends = n >= 4 && b >= CW + 10 ? 1 : 0, sides = Math.max(0, n - 2 * ends), topN = Math.ceil(sides / 2), botN = Math.floor(sides / 2);
      var tw = a * s, th = b * s, tx = cx - tw / 2, ty = cy - th / 2, k;
      var along = function (k, N) { var span = N * CW <= a ? tw : N * (CW + 2) * s; return cx - span / 2 + span * (k + 0.5) / N; };
      for (k = 0; k < topN; k++) chair(along(k, topN), ty - (GAP + CD / 2) * s, 0);
      for (k = 0; k < botN; k++) chair(along(k, botN), ty + th + (GAP + CD / 2) * s, 180);
      if (botN) chairDim(along(0, botN), ty + th + OUT * s);
      if (ends) { chair(tx - (GAP + CD / 2) * s, cy, -90); chair(tx + tw + (GAP + CD / 2) * s, cy, 90); }
      top('<rect x="' + r(tx) + '" y="' + r(ty) + '" width="' + r(tw) + '" height="' + r(th) + '" rx="3"/>', tx, ty, tw, th);
      var ly = ty - (topN ? OUT : 0) * s - 22;
      out.push('<path d="M' + r(tx) + ' ' + r(ly - 10) + 'v20M' + r(tx) + ' ' + r(ly) + 'H' + r(tx + tw) + 'M' + r(tx + tw) + ' ' + r(ly - 10) + 'v20" stroke="' + INK + '" stroke-width="3" fill="none"/>');
      lbl(cx, ly - 18, a + ' cm');
      var lx = tx + tw + (ends ? OUT : 0) * s + 24;
      out.push('<path d="M' + r(lx - 10) + ' ' + r(ty) + 'h20M' + r(lx) + ' ' + r(ty) + 'V' + r(ty + th) + 'M' + r(lx - 10) + ' ' + r(ty + th) + 'h20" stroke="' + INK + '" stroke-width="3" fill="none"/>');
      lbl(lx + 30, cy, b + ' cm', 90);
    } else {
      var R = a / 2 * s;
      for (var i = 0; i < n; i++) {
        var ang = -90 + 360 * i / n, rad = ang * Math.PI / 180, dist = R + (GAP + CD / 2) * s;
        chair(cx + Math.cos(rad) * dist, cy + Math.sin(rad) * dist, ang + 90);
        if (ang === 90) chairDim(cx, cy + R + OUT * s);
      }
      top('<circle cx="' + r(cx) + '" cy="' + r(cy) + '" r="' + r(R) + '"/>', cx - R, cy - R, 2 * R, 2 * R);
      out.push('<line x1="' + r(cx - R) + '" y1="' + r(cy) + '" x2="' + r(cx + R) + '" y2="' + r(cy) + '" stroke="' + INK + '" stroke-width="3" stroke-dasharray="10 8"/>');
      lbl(cx, cy - 16, 'Ø ' + a + ' cm');
    }
    fig.classList.add('is-room');
    fig.classList.remove('is-room-wait');
    svg.setAttribute('viewBox', '0 0 1024 1024');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.innerHTML = out.join('');
    var cm = info.cm || info.value;
    svg.setAttribute('aria-label', 'Üstten ölçü çizimi: ' + cm + (kind === 'circle' ? ' yuvarlak' : '') + ' masa ve ' + n + ' sandalye' + (chairW ? ' (sandalye genişliği ' + CW + ' cm' + (chairW.name ? ', ' + chairW.name : '') + ')' : '') + ', yaklaşık 4,3 × 4,3 m bir odada');
    if (cap) cap.textContent = n + ' kişilik · ' + cm + ' · oda yaklaşık 4,3 × 4,3 m';
  };

  /* "Ölçü çizimini görün": desktop scrolls the grid tile into view, phones slide the gallery to it */
  Pdp.prototype.openDrawing = function () {
    var fig = this.dw;
    if (!fig) return;
    var slide = fig.closest('[data-vor-slide]');
    var i = this.slides ? this.slides.indexOf(slide) : -1;
    var desktop = window.matchMedia('(min-width: 990px)').matches;
    if (desktop) {
      if (slide && slide.classList.contains('vor-pdp-g__slide--more') && this.expandGallery) this.expandGallery();
      fig.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
    } else {
      if (i > -1) this.go(i);
      var g = $(this.root, '[data-vor-gallery]');
      if (g) g.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
    }
    fig.focus({ preventScroll: true });
  };

  /* ---------- Chairs (snippets/vor-pdp-chairs) ----------
     window.vornomCombineChairs.items() -> [{ id, quantity, price }] for the picked chairs (1-10, as the
     live box); .clear() unpicks them after the add. "+ Ekle" picks a chair at the recommended count
     (data-vor-ch-rec, follows the size); minus at 1 and "Çıkar" unpick it; focus stays in the row. */
  Pdp.prototype.chairItems = function () {
    var api = window.vornomCombineChairs;
    return api && typeof api.items === 'function' ? api.items() : [];
  };

  Pdp.prototype.initChairs = function () {
    var self = this, box = $(this.root, '[data-vor-chairs]');
    if (!box) return;
    function clamp(input) {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 10) n = 10;
      input.value = n;
      return n;
    }
    function refresh(item) {
      var n = clamp($(item, '[data-combine-chair-qty]'));
      var unit = Number(item.getAttribute('data-unit-price')) || 0;
      $$(item, '[data-vor-ch-unit]').forEach(function (el) { el.textContent = self.money(unit) + ' / adet'; });
      var total = $(item, '[data-vor-ch-total]');
      if (total) total.textContent = n + ' adet = ' + self.money(unit * n);
      var plus = $(item, '[data-combine-qty-plus]');
      if (plus) plus.disabled = n >= 10;
    }
    function pick(item, on, focus) {
      item.classList.toggle('is-selected', on);
      $(item, '[data-vor-ch-picked]').hidden = !on;
      var add = $(item, '[data-combine-chair-toggle]');
      add.hidden = on;
      var qty = $(item, '[data-combine-chair-qty]');
      if (on) qty.value = box.getAttribute('data-vor-ch-rec') || 1;
      refresh(item);
      self.updateButtons();
      self.redrawDw();
      if (focus) (on ? qty : add).focus();
    }
    box.addEventListener('click', function (e) {
      var more = e.target.closest('[data-vor-ch-more]');
      if (more) {
        var extra = $$(box, '[data-vor-ch-extra]');
        extra.forEach(function (li) { li.hidden = false; });
        more.setAttribute('aria-expanded', 'true');
        more.hidden = true;
        var first = extra[0] && $(extra[0], '[data-combine-chair-toggle]');
        if (first) first.focus();
        return;
      }
      var item = e.target.closest('[data-combine-chair]');
      if (!item) return;
      if (e.target.closest('[data-combine-chair-toggle]')) return pick(item, true, true);
      if (e.target.closest('[data-vor-ch-remove]')) return pick(item, false, true);
      var minus = e.target.closest('[data-combine-qty-minus]');
      var plus = e.target.closest('[data-combine-qty-plus]');
      if (!minus && !plus) return;
      var qty = $(item, '[data-combine-chair-qty]');
      var n = clamp(qty) + (plus ? 1 : -1);
      if (n < 1) return pick(item, false, true);
      qty.value = Math.min(n, 10);
      refresh(item);
      self.updateButtons();
    });
    box.addEventListener('change', function (e) {
      var item = e.target.closest('[data-combine-chair]');
      if (!item) return;
      var sel = e.target.closest('[data-combine-chair-variant]');
      if (sel) {
        var o = sel.options[sel.selectedIndex];
        item.setAttribute('data-variant-id', o.value);
        item.setAttribute('data-unit-price', o.getAttribute('data-price'));
        var img = $(item, '.vor-ch__img img');
        if (img && o.getAttribute('data-image')) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = o.getAttribute('data-image');
        }
      }
      refresh(item);
      self.updateButtons();
    });
    // typed counts: totals follow at once, the field is clamped on change
    box.addEventListener('input', function (e) {
      if (e.target.closest('[data-combine-chair-qty]')) self.updateButtons();
    });
    function picked() { return $$(box, '[data-combine-chair].is-selected'); }
    window.vornomCombineChairs = {
      items: function () {
        return picked().map(function (item) {
          var q = $(item, '[data-combine-chair-qty]');
          var n = parseInt(q.value, 10);
          return { id: Number(item.getAttribute('data-variant-id')), quantity: Math.min(Math.max(isNaN(n) ? 1 : n, 1), 10), price: Number(item.getAttribute('data-unit-price')) || 0 };
        });
      },
      clear: function () { picked().forEach(function (item) { pick(item, false, false); }); }
    };
  };

  Pdp.prototype.updateButtons = function () {
    var v = this.variant, root = this.root;
    if (!v) return;
    var chairs = this.chairItems();
    var total = v.price, seats = 0;
    chairs.forEach(function (c) { total += (c.price || 0) * c.quantity; seats += c.quantity; });
    var label = $(root, '[data-vor-atc-label]');
    var price = $(root, '[data-vor-atc-price]');
    if (this.atc) {
      this.atc.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Sepete ekle' : 'Tükendi';
      if (price) { price.hidden = !v.available; price.textContent = '· ' + this.money(total); }
    }
    /* board 01: "Masa ve N sandalye birlikte sepete eklenir." under the button; the bar adds
       "N sandalyeyle <total>" after the table's price */
    var help = $(root, '[data-vor-atc-help]');
    if (help) {
      help.hidden = !seats || !v.available;
      help.textContent = seats ? 'Masa ve ' + seats + ' sandalye birlikte sepete eklenir.' : '';
    }
    var barChairs = $(root, '[data-vor-bar-chairs]');
    if (barChairs) {
      barChairs.hidden = !seats;
      barChairs.textContent = seats ? seats + ' sandalyeyle ' + this.money(total) : '';
    }
    var barBtn = $(root, '[data-vor-bar-btn]');
    if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = v.available ? 'Sepete ekle' : 'Tükendi'; }
    var barPrice = $(root, '[data-vor-bar-price]');
    if (barPrice) barPrice.textContent = this.money(v.price);
    /* sticky bar: the struck price only for the piece alone */
    var barCmp = $(root, '[data-vor-bar-compare]');
    if (barCmp) {
      var showBar = v.compare > v.price && !chairs.length;
      barCmp.hidden = !showBar;
      if (showBar) $(barCmp, '[data-vor-bar-compare-amount]').textContent = this.money(v.compare);
    }
  };

  /* ---------- Add to cart ---------- */
  Pdp.prototype.initForm = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      self.add();
    });
  };

  Pdp.prototype.add = function () {
    var self = this, form = this.form, atc = this.atc;
    if (this.busy || !this.variant || !this.variant.available) return;
    this.busy = true;
    $$(this.root, '[data-vor-error]').forEach(function (err) { err.hidden = true; err.textContent = ''; });
    if (atc) atc.classList.add('is-loading');

    var items = [{ id: this.variant.id, quantity: 1 }];
    var chairs = this.chairItems();
    var chairCount = 0;
    chairs.forEach(function (c) { items.push({ id: c.id, quantity: c.quantity }); chairCount += c.quantity; });
    var body = { items: items };
    var drawerSection = window.theme && theme.cart && theme.cart.drawerSection;
    if (drawerSection) { body.sections = drawerSection; body.sections_url = window.location.pathname; }

    form.dispatchEvent(new CustomEvent('ajaxProduct:adding', { bubbles: true }));

    var routes = (window.theme && theme.routes) || {};
    var url = routes.cartAdd || '/cart/add.js';
    if (!/\.js$/.test(url)) url += '.js';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        self.busy = false;
        if (atc) atc.classList.remove('is-loading');
        if (!r.ok || r.data.status) {
          self.fail(r.data && (r.data.description || r.data.message));
          return;
        }
        // Listeners expect one line item (theme.AjaxProduct posts a single id): pass the main line,
        // named "<product> + N sandalye" when chairs came along, with the drawer sections.
        var line = Object.assign({}, (r.data.items && r.data.items[0]) || {});
        if (chairCount && line.product_title) {
          line.product_title = String(line.product_title).split(',')[0].trim() + ' + ' + chairCount + ' sandalye';
        }
        line.sections = r.data.sections;
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: line, sections: r.data.sections, items: r.data.items, addToCartBtn: atc }
        }));
        if (chairs.length && window.vornomCombineChairs && window.vornomCombineChairs.clear) {
          window.vornomCombineChairs.clear();
          self.updateButtons();
        }
        if (!drawerSection || !document.getElementById('CartDrawer')) {
          window.location.href = (routes.cartPage || '/cart');
        }
      })
      .catch(function () {
        self.busy = false;
        if (atc) atc.classList.remove('is-loading');
        self.fail();
      });
  };

  Pdp.prototype.fail = function (msg) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:addFailed'));
    $$(this.root, '[data-vor-error]').forEach(function (err) {
      err.textContent = typeof msg === 'string' && msg ? msg : 'Ürün sepete eklenemedi. Lütfen tekrar deneyin ya da WhatsApp\'tan bize yazın.';
      err.hidden = false;
    });
  };

  /* ---------- PayTR table (snippets/vor-pdp-paytr) ----------
     Opened with style.display = 'block' (assets/vor-events.js reads it to send taksit_open on opening
     only). The PayTR script loads on the first opening with the selected variant's price; after a
     variant change it reloads on the next opening (or at once while open). */
  Pdp.prototype.initPaytr = function () {
    var self = this, btn = $(this.root, '[data-vor-paytr]');
    var body = document.getElementById('accordion-content');
    if (!btn || !body) return;
    var loadedFor = null;
    function load() {
      var amount = btn.getAttribute('data-vor-paytr-amount');
      if (loadedFor === amount) return;
      loadedFor = amount;
      var holder = document.getElementById('paytr_taksit_tablosu');
      if (holder) holder.innerHTML = '';
      var s = document.createElement('script');
      s.src = btn.getAttribute('data-vor-paytr-src') + '&amount=' + encodeURIComponent(amount);
      document.body.appendChild(s);
    }
    function set(open) {
      body.style.display = open ? 'block' : 'none';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) load();
    }
    btn.addEventListener('click', function () { set(body.style.display !== 'block'); });
    this.paytrStale = function () { if (body.style.display === 'block') load(); };
    window.vorPaytrOpen = function () { if (body.style.display !== 'block') set(true); return btn; };

    /* "Taksit seçenekleri" link in the price card (snippets/vor-taksit-line): open, bring into view,
       move focus. Its taksit_open (price_card) comes from its data-vor-event; opening here is no click
       on the accordion button, so no second event. */
    this.root.addEventListener('click', function (evt) {
      var link = evt.target.closest && evt.target.closest('[data-vor-taksit-open]');
      if (!link) return;
      set(true);
      link.setAttribute('aria-expanded', 'true');
      btn.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      if (!body.hasAttribute('tabindex')) body.setAttribute('tabindex', '-1');
      body.focus({ preventScroll: true });
    });
  };

  /* ---------- Gallery ---------- */
  Pdp.prototype.initGallery = function () {
    var self = this, g = $(this.root, '[data-vor-gallery]');
    if (!g) return;
    this.track = $(g, '[data-vor-track]');
    this.slides = $$(g, '[data-vor-slide]');
    this.thumbs = $$(g, '[data-vor-thumb]');
    this.count = $(g, '[data-vor-count]');
    this.prev = $(g, '[data-vor-prev]');
    this.next = $(g, '[data-vor-next]');
    this.index = 0;
    if (!this.track || !this.slides.length) return;

    var raf = 0;
    this.track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var w = self.track.clientWidth || 1;
        self.setIndex(Math.round(self.track.scrollLeft / w));
      });
    }, { passive: true });

    this.thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { self.go(Number(btn.getAttribute('data-vor-thumb'))); });
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
    });

    // external videos load on tap
    $$(g, '[data-vor-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tpl = btn.parentNode.querySelector('template[data-vor-video]');
        if (!tpl) return;
        btn.replaceWith(tpl.content.cloneNode(true));
      });
    });

    // pause native videos that scroll away
    this.track.addEventListener('scroll', function () {
      $$(self.track, 'video').forEach(function (v) { if (!v.paused) { var r = v.getBoundingClientRect(), t = self.track.getBoundingClientRect(); if (r.right <= t.left + 1 || r.left >= t.right - 1) v.pause(); } });
    }, { passive: true });

    /* native gallery videos: one play/pause button in the middle (no browser control bar); a tap on the
       playing video pauses it too. The slide gets is-playing so the button hides while it plays. */
    g.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vor-vtoggle]');
      var v = btn ? btn.parentNode.querySelector('video') : (e.target.matches && e.target.matches('video.vor-pdp-g__video') ? e.target : null);
      if (!v) return;
      e.preventDefault();
      if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause();
    });
    ['play', 'pause', 'ended'].forEach(function (type) {
      g.addEventListener(type, function (e) {
        var v = e.target;
        if (!v.matches || !v.matches('video.vor-pdp-g__video')) return;
        var on = !v.paused && !v.ended;
        var li = v.parentNode;
        li.classList.toggle('is-playing', on);
        var b = li.querySelector('[data-vor-vtoggle]');
        if (b) b.setAttribute('aria-label', on ? 'Videoyu durdur' : 'Videoyu oynat');
      }, true);
    });

    var more = $(g, '[data-vor-more]');
    /* gallery videos come as <template data-vor-later> so their posters don't load early: desktop fills
       the visible grid at once (the rest on "Daha fazla görsel"); phones fill a slide's video when the
       slide comes within one slide of view. */
    function fillOne(tpl) { if (tpl.parentNode) tpl.replaceWith(tpl.content.cloneNode(true)); }
    function fillLater() { $$(g, 'template[data-vor-later]').forEach(fillOne); }
    function fillVisibleGrid() {
      $$(g, 'template[data-vor-later]').forEach(function (tpl) {
        var li = tpl.closest('[data-vor-slide]');
        if (li && !li.classList.contains('vor-pdp-g__slide--more')) fillOne(tpl);
      });
    }
    function fillNearOnPhones() {
      if (!('IntersectionObserver' in window)) { fillLater(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var tpl = $(e.target, 'template[data-vor-later]');
          if (tpl) fillOne(tpl);
        });
      }, { root: self.track, rootMargin: '0px 100% 0px 100%' });
      $$(g, 'template[data-vor-later]').forEach(function (tpl) { var li = tpl.closest('[data-vor-slide]'); if (li) io.observe(li); });
    }
    var phone = window.matchMedia('(max-width: 989px)');
    if (phone.matches) fillNearOnPhones(); else fillVisibleGrid();
    if (phone.addEventListener) phone.addEventListener('change', function (e) { if (e.matches) fillNearOnPhones(); else fillVisibleGrid(); });
    this.expandGallery = function () {
      if (!more || g.classList.contains('is-all')) return false;
      fillLater();
      g.classList.add('is-all');
      more.setAttribute('aria-expanded', 'true');
      return true;
    };
    /* Desktop: show more than 6 tiles when the buy box beside the gallery is taller (UPP owner
       2026-10-17). Tiles after the 6th are revealed in order while the grid is still shorter than the
       buy box (by more than 40px). Only ever reveals; re-runs when the buy box grows. */
    var buy = $(this.root, '.vor-pdp__buy');
    var moreLabel = more ? more.firstChild : null;
    function sameRowSquare(li) {
      var prev = li.previousElementSibling;
      li.classList.remove('vor-pdp-g__slide--more');
      var same = prev && Math.abs(li.offsetTop - prev.offsetTop) < 2;
      li.classList.add('vor-pdp-g__slide--more');
      return same;
    }
    function fitToBuy() {
      if (!more || !buy || !self.track || phone.matches || g.classList.contains('is-all')) return;
      var limit = buy.offsetHeight;
      var rest = $$(g, '.vor-pdp-g__slide--more');
      var shown = 0;
      for (var i = 0; i < rest.length; i++) {
        var li = rest[i];
        if (self.track.offsetHeight >= limit - 40 && !(li.previousElementSibling && !li.previousElementSibling.classList.contains('vor-pdp-g__slide--more') && sameRowSquare(li))) break;
        li.classList.remove('vor-pdp-g__slide--more');
        var tpl = $(li, 'template[data-vor-later]');
        if (tpl) fillOne(tpl);
        shown++;
      }
      if (!shown) return;
      var left = rest.length - shown;
      if (!left) { g.classList.add('is-all'); more.setAttribute('aria-expanded', 'true'); }
      else if (moreLabel && moreLabel.nodeType === 3) moreLabel.nodeValue = moreLabel.nodeValue.replace(/\(\d+\)/, '(' + left + ')');
    }
    fitToBuy();
    if (buy && 'ResizeObserver' in window) new ResizeObserver(fitToBuy).observe(buy);

    if (more) more.addEventListener('click', function () {
      self.expandGallery();
      var first = $(g, '.vor-pdp-g__slide--more');
      var target = first && first.querySelector('button, video, iframe');
      if (first && !target) { first.tabIndex = -1; target = first; }
      if (target) target.focus();
    });

    this.initZoom(g);
    var start = this.variant ? this.variant.media : null;
    if (start) this.showMedia(start, true);
  };

  Pdp.prototype.setIndex = function (i) {
    if (!this.slides) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.index = i;
    if (this.count) this.count.textContent = i + 1;
    if (this.prev) this.prev.disabled = i === 0;
    if (this.next) this.next.disabled = i === this.slides.length - 1;
    this.thumbs.forEach(function (t) {
      var on = Number(t.getAttribute('data-vor-thumb')) === i;
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    var active = this.thumbs[i];
    if (active && active.parentNode && active.parentNode.parentNode) {
      var list = active.parentNode.parentNode, li = active.parentNode;
      var vertical = list.scrollHeight > list.clientHeight + 2 && getComputedStyle(list).flexDirection === 'column';
      if (vertical) {
        if (li.offsetTop < list.scrollTop || li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop - 8;
      } else if (li.offsetLeft < list.scrollLeft || li.offsetLeft + li.offsetWidth > list.scrollLeft + list.clientWidth) {
        list.scrollLeft = li.offsetLeft - 16;
      }
    }
  };

  Pdp.prototype.go = function (i, instant) {
    if (!this.track) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    var left = this.slides[i].offsetLeft - this.slides[0].offsetLeft;
    if (instant) {
      var prevBehavior = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      this.track.style.scrollBehavior = prevBehavior;
    } else {
      this.track.scrollTo({ left: left, behavior: reduced() ? 'auto' : 'smooth' });
    }
    this.setIndex(i);
  };

  Pdp.prototype.showMedia = function (mediaId, instant) {
    if (!mediaId || !this.slides) return;
    /* Desktop grid: nothing to scroll to, but open the collapsed tiles if the variant's image is among them. */
    if (window.matchMedia('(min-width: 990px)').matches) {
      var hit = this.slides.filter(function (s) { return Number(s.getAttribute('data-media-id')) === mediaId; })[0];
      if (hit && hit.classList.contains('vor-pdp-g__slide--more') && this.expandGallery) this.expandGallery();
      return;
    }
    for (var i = 0; i < this.slides.length; i++) {
      if (Number(this.slides[i].getAttribute('data-media-id')) === mediaId) { if (i !== this.index) this.go(i, instant); return; }
    }
  };

  /* ---------- Zoom viewer ----------
     2026-10-27 (owner: the IWA / CFW zoom, kept in Vornom's look; port of UPP's initZoom). Every photo and the size
     drawing in gallery order (videos stay out), side by side in one track moved by transform: a swipe, the arrows,
     the arrow keys or a thumbnail changes the item; a pinch, a double tap, the bar's zoom button or a mouse click zooms
     a photo in at that point (2.5x, at least 2x when the file is small; pinch up to 4x or the file's size); a zoomed photo pans under
     the finger or the mouse and the swipe waits until it is zoomed out. The stage is touch-action: none, so the page
     never pinch-zooms behind it. The drawing is a page: a copy of the gallery figure without data-vor-dw, ids or
     listeners (the size code leaves it alone), copied again whenever the original changes; a size chip in it clicks
     the original's chip, so the variant, price and URL follow the usual path. The variant label and the selling
     points over a photo come under it here. Slides and thumbnails are built on the first open; each photo loads its
     2000px file when it or a neighbour is shown, over the gallery's own copy. */
  Pdp.prototype.initZoom = function (g) {
    var self = this, dlg = $(g, '[data-vor-zoom-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var stage = $(dlg, '[data-vor-zoom-stage]'), track = $(dlg, '[data-vor-zoom-track]'), strip = $(dlg, '[data-vor-zoom-thumbs]');
    var count = $(dlg, '[data-vor-zoom-count]'), toggle = $(dlg, '[data-vor-zoom-toggle]');
    var prev = $(dlg, '[data-vor-zoom-prev]'), next = $(dlg, '[data-vor-zoom-next]');
    var TAP = 2.5, MAX = 4;
    var items = [], at = 0, built = false, opener = null, resetT = 0;
    this.slides.forEach(function (s) {
      var btn = s.querySelector('[data-vor-zoom]');
      if (btn) items.push({ slide: s, btn: btn, kind: 'image' });
      else if (s.getAttribute('data-kind') === 'drawing' && s.querySelector('[data-vor-dw]')) items.push({ slide: s, kind: 'page', src: s.querySelector('[data-vor-dw]') });
    });
    if (!items.some(function (it) { return it.kind === 'image'; })) return;

    function caption(slide) {
      var vl = $(slide, '.vor-pdp-g__vlabel'), pts = $$(slide, '.vor-pdp-pts li');
      if (!vl && !pts.length) return null;
      var box = document.createElement('div');
      box.className = 'vor-pdp-zoom__cap';
      if (vl) {
        var tag = document.createElement('p');
        tag.className = 'vor-pdp-zoom__tag';
        tag.textContent = vl.textContent;
        box.appendChild(tag);
      }
      if (pts.length) {
        var ul = document.createElement('ul');
        ul.setAttribute('role', 'list');
        pts.forEach(function (p) { var li = document.createElement('li'); li.textContent = p.textContent; ul.appendChild(li); });
        box.appendChild(ul);
      }
      return box;
    }
    function copyPage(it) {
      var c = it.src.cloneNode(true);
      c.removeAttribute('data-vor-dw');
      $$(c, '[id]').forEach(function (n) { n.removeAttribute('id'); });
      $$(c, '[aria-labelledby]').forEach(function (n) { n.removeAttribute('aria-labelledby'); });
      $$(c, '.vor-pdp-dw__size').forEach(function (b, i) { b.setAttribute('data-vor-zoom-chip', i); });
      it.sheet.textContent = '';
      it.sheet.appendChild(c);
      /* a chip row wider than the page: the picked chip in the middle */
      $$(c, '.vor-pdp-dw__sizes').forEach(function (row) {
        var on = $(row, '[aria-pressed="true"]');
        if (on && row.scrollWidth > row.clientWidth) row.scrollLeft += on.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - on.offsetWidth) / 2;
      });
    }
    function watchPages(on) {
      items.forEach(function (it) {
        if (it.kind !== 'page' || !('MutationObserver' in window)) return;
        if (on && !it.obs) {
          var raf = 0;
          it.obs = new MutationObserver(function () {
            if (raf) return;
            raf = window.requestAnimationFrame(function () { raf = 0; copyPage(it); });
          });
          it.obs.observe(it.src, { subtree: true, childList: true, attributes: true, characterData: true });
        } else if (!on && it.obs) {
          it.obs.disconnect();
          it.obs = null;
        }
      });
    }
    function build() {
      built = true;
      items.forEach(function (it, k) {
        var li = document.createElement('li');
        li.className = 'vor-pdp-zoom__slide';
        if (it.kind === 'image') {
          var small = it.btn.querySelector('img'), frame = document.createElement('div'), img = document.createElement('img');
          var w = small ? Number(small.getAttribute('width')) : 0, h = small ? Number(small.getAttribute('height')) : 0;
          it.ratio = w && h ? w / h : 1;
          it.z = { s: 1, x: 0, y: 0 };
          frame.className = 'vor-pdp-zoom__frame';
          img.className = 'vor-pdp-zoom__img';
          img.alt = small ? small.alt : '';
          img.decoding = 'async';
          img.draggable = false;
          img.addEventListener('load', function () {
            img.style.backgroundImage = '';
            if (!img.naturalWidth) return;
            it.nw = img.naturalWidth;
            var r = img.naturalWidth / img.naturalHeight;
            if (Math.abs(r - it.ratio) > 0.01) { it.ratio = r; fit(it); }
          });
          frame.appendChild(img);
          li.appendChild(frame);
          var cap = caption(it.slide);
          if (cap) li.appendChild(cap);
          it.small = small;
          it.frame = frame;
          it.img = img;
        } else {
          var pg = document.createElement('div'), sheet = document.createElement('div');
          pg.className = 'vor-pdp-zoom__page';
          sheet.className = 'vor-pdp-zoom__sheet';
          pg.appendChild(sheet);
          li.appendChild(pg);
          it.frame = pg;
          it.sheet = sheet;
          sheet.addEventListener('click', function (e) {
            var c = e.target.closest('[data-vor-zoom-chip]');
            var real = c && $$(it.src, '.vor-pdp-dw__size')[Number(c.getAttribute('data-vor-zoom-chip'))];
            if (real) real.click();
          });
        }
        it.li = li;
        track.appendChild(li);
        /* thumbnail: the gallery's own (photo or "Ölçüler"), numbered for the viewer */
        var src = $(g, '[data-vor-thumb="' + it.slide.getAttribute('data-index') + '"]');
        var tli = document.createElement('li'), b = document.createElement('button');
        b.type = 'button';
        b.className = src ? src.className : 'vor-pdp-g__thumb';
        if (src) b.innerHTML = src.innerHTML;
        b.setAttribute('aria-label', it.kind === 'page' && src ? src.getAttribute('aria-label') : 'Görsel ' + (k + 1) + '/' + items.length);
        b.addEventListener('click', function () { go(k, true); });
        tli.appendChild(b);
        strip.appendChild(tli);
        it.thumb = b;
      });
      var one = items.length < 2;
      strip.hidden = one;
      count.hidden = one;
      prev.hidden = one;
      next.hidden = one;
    }

    /* zoom state per photo: s = scale of the fitted size, x / y = top left of the scaled photo in its frame */
    function bounds(it, s) {
      var w = it.fw * s, h = it.fh * s;
      return {
        x0: w <= it.W ? (it.W - w) / 2 : it.W - w, x1: w <= it.W ? (it.W - w) / 2 : 0,
        y0: h <= it.H ? (it.H - h) / 2 : it.H - h, y1: h <= it.H ? (it.H - h) / 2 : 0
      };
    }
    function clampZ(it, z) {
      var b = bounds(it, z.s);
      return { s: z.s, x: Math.min(b.x1, Math.max(b.x0, z.x)), y: Math.min(b.y1, Math.max(b.y0, z.y)) };
    }
    function maxS(it) { return Math.max(TAP, Math.min(MAX, (it.nw || 2000) / it.fw)); }
    function paint(it, anim) {
      it.img.style.transition = anim && !reduced() ? 'transform .25s ease-out' : 'none';
      it.img.style.transform = 'translate3d(' + it.z.x + 'px,' + it.z.y + 'px,0) scale(' + it.z.s + ')';
      if (it === items[at]) syncBar();
    }
    /* fit the photo in its frame; keep a zoom (resize, rotation) but bring it back inside */
    function fit(it) {
      if (it.kind !== 'image') return;
      var W = it.frame.clientWidth, H = it.frame.clientHeight;
      if (!W || !H) return;
      var keep = it.z.s > 1.01 && it.fw;
      var cx = keep ? (W / 2 - it.z.x) / (it.fw * it.z.s) : 0, cy = keep ? (H / 2 - it.z.y) / (it.fh * it.z.s) : 0;
      it.W = W;
      it.H = H;
      it.fw = Math.min(W, H * it.ratio);
      it.fh = it.fw / it.ratio;
      it.img.style.width = it.fw + 'px';
      it.img.style.height = it.fh + 'px';
      it.z = keep ? clampZ(it, { s: it.z.s, x: W / 2 - cx * it.fw * it.z.s, y: H / 2 - cy * it.fh * it.z.s }) : { s: 1, x: (W - it.fw) / 2, y: (H - it.fh) / 2 };
      paint(it, false);
    }
    function zoomTo(it, s, px, py, anim) {
      var ix = (px - it.z.x) / it.z.s, iy = (py - it.z.y) / it.z.s;
      it.z = clampZ(it, { s: s, x: px - ix * s, y: py - iy * s });
      paint(it, anim);
    }
    /* a tap or click: 2.5x, or on a big screen the file's own size when that is less, but at least 2x */
    function tapS(it) { return Math.max(2, Math.min(TAP, (it.nw || 2000) / it.fw)); }
    function tapZoom(it, px, py) { zoomTo(it, it.z.s > 1.01 ? 1 : tapS(it), px, py, true); }
    /* after a pinch or pan: scale back between 1 and the top, photo back inside its frame */
    function settle(it) {
      var s = Math.max(1, Math.min(maxS(it), it.z.s));
      zoomTo(it, s, it.W / 2, it.H / 2, true);
    }
    function syncBar() {
      var it = items[at], page = it.kind === 'page', on = !page && it.z.s > 1.01;
      dlg.classList.toggle('is-zoomed', on);
      dlg.classList.toggle('is-page', page);
      toggle.hidden = page;
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.setAttribute('aria-label', on ? 'Uzaklaştır' : 'Yakınlaştır');
    }

    function place(dx, anim) {
      track.style.transition = anim && !reduced() ? 'transform .3s ease-out' : 'none';
      track.style.transform = 'translate3d(' + (-at * stage.clientWidth + dx) + 'px,0,0)';
    }
    function load(k) {
      var it = items[k];
      if (!it || it.kind !== 'image' || it.img.getAttribute('src')) return;
      var cur = it.small && (it.small.currentSrc || it.small.getAttribute('src'));
      if (cur) it.img.style.backgroundImage = 'url("' + cur + '")';
      it.img.src = it.btn.getAttribute('data-zoom-src');
    }
    function showThumb(b) {
      var li = b.parentNode;
      if (getComputedStyle(strip).flexDirection === 'column') strip.scrollTop = li.offsetTop - (strip.clientHeight - li.offsetHeight) / 2;
      else strip.scrollLeft = li.offsetLeft - (strip.clientWidth - li.offsetWidth) / 2;
    }
    /* arrows at the middle of the shown photo (a caption under it makes its frame shorter than the stage) */
    function setMid() {
      var f = items[at].frame;
      stage.style.setProperty('--vor-zoom-mid', (f.offsetTop + f.offsetHeight / 2) + 'px');
    }
    function go(k, anim) {
      k = Math.max(0, Math.min(items.length - 1, k));
      var was = items[at];
      at = k;
      place(0, anim);
      /* photos left zoomed come back to fit once they are out of view */
      if (was !== items[k]) {
        window.clearTimeout(resetT);
        resetT = window.setTimeout(function () {
          items.forEach(function (it, i) { if (i !== at && it.kind === 'image' && it.z.s > 1.01) { it.z.s = 1; fit(it); } });
        }, anim ? 320 : 0);
      }
      items.forEach(function (it, i) {
        if (i === k) { it.li.removeAttribute('inert'); it.thumb.setAttribute('aria-current', 'true'); }
        else { it.li.setAttribute('inert', ''); it.thumb.removeAttribute('aria-current'); }
      });
      load(k);
      load(k + 1);
      load(k - 1);
      count.textContent = (k + 1) + ' / ' + items.length;
      prev.disabled = k === 0;
      next.disabled = k === items.length - 1;
      showThumb(items[k].thumb);
      setMid();
      syncBar();
    }
    function layout() {
      items.forEach(fit);
      place(0, false);
      setMid();
    }
    function open(k) {
      if (!built) build();
      items.forEach(function (it) { if (it.kind === 'page') copyPage(it); });
      watchPages(true);
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      items.forEach(function (it) { if (it.kind === 'image') it.z.s = 1; fit(it); });
      at = k;
      go(k, false);
    }

    items.forEach(function (it, k) {
      if (it.btn) it.btn.addEventListener('click', function (e) { opener = e.currentTarget; open(k); });
    });
    $(dlg, '[data-vor-zoom-close]').addEventListener('click', function () { dlg.close(); });
    prev.addEventListener('click', function () { go(at - 1, true); });
    next.addEventListener('click', function () { go(at + 1, true); });
    toggle.addEventListener('click', function () { var it = items[at]; if (it.kind === 'image') tapZoom(it, it.W / 2, it.H / 2); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1, true); }
    });
    /* iOS: no page pinch behind the viewer */
    dlg.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (dlg.open && built) layout(); }).observe(stage);

    /* gestures: one pointer swipes (or pans a zoomed photo), two pinch; a tap is a mouse click or half a double tap.
       Pointers that start on a button, link or the drawing's size chips and caption are left to them. */
    var pts = {}, one = null, pinch = null, lastTap = null;
    function pair() { var k = Object.keys(pts); return [pts[k[0]], pts[k[1]]]; }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button, a, input, label, .vor-pdp-dw__foot')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* already released */ }
      var it = items[at], n = Object.keys(pts).length;
      if (n === 1) {
        one = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), zx: it.z ? it.z.x : 0, zy: it.z ? it.z.y : 0, mode: '', type: e.pointerType };
      } else if (n === 2) {
        if (one && one.mode === 'swipe') place(0, true);
        one = null;
        dlg.classList.remove('is-dragging');
        if (it.kind !== 'image') return;
        var p = pair(), r = it.frame.getBoundingClientRect();
        var mx = (p[0].x + p[1].x) / 2 - r.left, my = (p[0].y + p[1].y) / 2 - r.top;
        pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s: it.z.s, ix: (mx - it.z.x) / it.z.s, iy: (my - it.z.y) / it.z.s, r: r };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var it = items[at];
      if (pinch) {
        if (Object.keys(pts).length < 2) return;
        var p = pair(), top = maxS(it);
        var s = pinch.s * Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) / pinch.d;
        s = s < 1 ? 1 - (1 - s) / 3 : s > top ? top + (s - top) / 3 : s;
        it.z = { s: s, x: (p[0].x + p[1].x) / 2 - pinch.r.left - pinch.ix * s, y: (p[0].y + p[1].y) / 2 - pinch.r.top - pinch.iy * s };
        paint(it, false);
        return;
      }
      if (!one || one.id !== e.pointerId) return;
      var dx = e.clientX - one.x, dy = e.clientY - one.y;
      if (!one.mode) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        one.mode = it.kind === 'image' && it.z.s > 1.01 ? 'pan' : 'swipe';
        dlg.classList.add('is-dragging');
      }
      if (one.mode === 'pan') {
        var b = bounds(it, it.z.s), x = one.zx + dx, y = one.zy + dy;
        x = x > b.x1 ? b.x1 + (x - b.x1) / 3 : x < b.x0 ? b.x0 + (x - b.x0) / 3 : x;
        y = y > b.y1 ? b.y1 + (y - b.y1) / 3 : y < b.y0 ? b.y0 + (y - b.y0) / 3 : y;
        it.z = { s: it.z.s, x: x, y: y };
        paint(it, false);
      } else {
        place((at === 0 && dx > 0) || (at === items.length - 1 && dx < 0) ? dx / 3 : dx, false);
      }
    });
    function up(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      var it = items[at];
      if (pinch) {
        /* the pinch ends with its first lifted finger; the other one does nothing until it lifts too */
        pinch = null;
        settle(it);
        return;
      }
      if (!one || one.id !== e.pointerId) return;
      var dx = e.clientX - one.x, dt = Date.now() - one.t, mode = one.mode, type = one.type;
      one = null;
      dlg.classList.remove('is-dragging');
      if (mode === 'swipe') {
        if (e.type !== 'pointercancel' && (Math.abs(dx) > stage.clientWidth * 0.15 || (Math.abs(dx) > 20 && Math.abs(dx) / Math.max(dt, 1) > 0.4))) go(at + (dx < 0 ? 1 : -1), true);
        else place(0, true);
        return;
      }
      if (mode === 'pan') { settle(it); return; }
      if (e.type === 'pointercancel' || it.kind !== 'image') return;
      var r = it.frame.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top, now = Date.now();
      if (type === 'mouse') { tapZoom(it, px, py); return; }
      if (lastTap && now - lastTap.t < 320 && Math.hypot(lastTap.x - px, lastTap.y - py) < 40) {
        lastTap = null;
        tapZoom(it, px, py);
      } else {
        lastTap = { t: now, x: px, y: py };
      }
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    /* desktop: ctrl + wheel (a trackpad pinch) zooms, the wheel pans a zoomed photo */
    stage.addEventListener('wheel', function (e) {
      var it = items[at];
      if (it.kind !== 'image' || (!e.ctrlKey && it.z.s <= 1.01)) return;
      e.preventDefault();
      var r = it.frame.getBoundingClientRect();
      if (e.ctrlKey) zoomTo(it, Math.max(1, Math.min(maxS(it), it.z.s * Math.exp(-e.deltaY / 100))), e.clientX - r.left, e.clientY - r.top, false);
      else { it.z = clampZ(it, { s: it.z.s, x: it.z.x - e.deltaX, y: it.z.y - e.deltaY }); paint(it, false); }
    }, { passive: false });

    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      watchPages(false);
      pts = {};
      one = null;
      pinch = null;
      dlg.classList.remove('is-dragging');
      var it = items[at];
      if (it) self.go(self.slides.indexOf(it.slide), true);
      if (opener) {
        var o = it && it.btn;
        /* a tile still collapsed behind "Daha fazla görsel" can't take focus */
        if (o && !o.offsetParent) o = null;
        (o || opener).focus({ preventScroll: true });
      }
    });
  };

  /* ---------- Sticky bar (phones and desktop) ---------- */
  Pdp.prototype.initBar = function () {
    var self = this, bar = $(this.root, '[data-vor-bar]');
    if (!bar || !this.atc || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var btn = $(bar, '[data-vor-bar-btn]');
    btn.addEventListener('click', function () {
      /* Submit after this click has finished: submitting inside it opened the cart drawer, whose
         outside-click close then caught the same click, so the drawer opened, closed and opened again
         (UPP C84, c1664ea). */
      window.setTimeout(function () {
        if (self.form.requestSubmit) self.form.requestSubmit(self.atc);
        else self.atc.click();
      }, 0);
    });
    var mq = window.matchMedia('(max-width: 989px)');
    var past = false;
    function apply() {
      var on = past;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('vor-pdp-bar-on', on);
      if (on) document.documentElement.style.setProperty('--vor-pdp-bar-h', bar.offsetHeight + 'px');
    }
    new IntersectionObserver(function (entries) {
      past = !entries[0].isIntersecting;
      apply();
    }).observe(this.atc);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    apply();
  };

  /* ---------- Recently viewed (theme list) ---------- */
  Pdp.prototype.recordRecent = function () {
    try {
      var r = this.root, handle = r.getAttribute('data-product-handle');
      if (!handle) return;
      var store = window.theme && theme.recentlyViewed ? theme.recentlyViewed.recent : JSON.parse(localStorage.getItem('theme-recent') || '{}');
      delete store[handle];
      store[handle] = { url: r.getAttribute('data-product-url'), aspectRatio: r.getAttribute('data-aspect-ratio'), featuredImage: r.getAttribute('data-img-url') };
      localStorage.setItem('theme-recent', JSON.stringify(store));
    } catch (e) { /* storage blocked */ }
  };

  function boot() {
    $$(document, '[data-vor-pdp]').forEach(function (root) {
      if (root.__vorPdp) return;
      root.__vorPdp = new Pdp(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
